import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// import { AuthGuard } from './_helpers/auth.guard';
import { AuthGuard } from './auth/auth.guard';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";

import { AddClientComponent } from './clients/add-client.component';
import { EditClientComponent } from './clients/edit-client.component';
import { ClientsComponent } from './clients/clients.component';

import { AddSubmissionComponent } from './submissions/add-submission.component';
import { EditSubmissionComponent } from './submissions/edit-submission.component';
import { SubmissionsComponent } from './submissions/submissions.component';

import { AddPropositionComponent } from './propositions/add-proposition.component';
import { PropositionsComponent } from './propositions/propositions.component';

import { CalendarComponent } from './calendar/calendar.component';
import { CalendarJobsComponent } from './calendar-jobs/calendar-jobs.component';
import { CalendarForemanComponent } from './calendar-foreman/calendar-foreman.component';
import { FollowUpsComponent } from './follow-ups/follow-ups.component';

import { ContractsComponent } from './contracts/contracts.component';
import { EditContractComponent } from './contracts/edit-contract.component';

import { AddInvoiceComponent } from './invoices/add-invoice.component';
import { EditInvoiceComponent } from './invoices/edit-invoice.component';
import { InvoicesComponent } from './invoices/invoices.component';

//import { AddOrderComponent } from './orders/add-order.component';
import { EditOrderComponent } from './orders/edit-order.component';
import { OrdersComponent } from './orders/orders.component';

import { ManagementComponent } from './management/management.component';
import { EditOrdertemplateComponent } from './management/ordertemplate/edit-ordertemplate.component';
import { UsersComponent } from './management/users/users.component';
import { EditUserComponent } from './management/users/edit-user.component';
import { AddTemplateComponent } from './management/templates/add-template.component';
import { TemplatesComponent } from './management/templates/templates.component';
import { EditTemplateComponent } from './management/templates/edit-template.component';
import { ContractorsComponent } from './management/contractors/contractors.component';
import { EditContractorComponent } from './management/contractors/edit-contractor.component';
import { AddContractorComponent } from './management/contractors/add-contractor.component';

const routes: Routes = [
  { path: 'accueil', component: HomeComponent },
  { path: 'connexion', component: LoginComponent },
  { path: 'mot-de-passe-oublie', component: ForgotPasswordComponent },
  { path: 'modifier-le-mot-de-passe', component: ResetPasswordComponent },
  
  { path: 'ajouter-client', component: AddClientComponent, canActivate: [ AuthGuard ] },
  { path: 'clients', component: ClientsComponent, canActivate: [ AuthGuard ] },
  { path: 'client/:clientid/editer', component: EditClientComponent, canActivate: [ AuthGuard ] },
  
  { path: 'contrats', component: ContractsComponent, canActivate: [ AuthGuard ] },
  { path: 'contrat/:submissionid/editer', component: EditContractComponent, canActivate: [ AuthGuard ] },

  { path: 'factures', component: InvoicesComponent, canActivate: [ AuthGuard ] },
  { path: 'facture/:factureid/editer', component: EditInvoiceComponent, canActivate: [ AuthGuard ]},
  { path: 'facture/ajouter', component: AddInvoiceComponent, canActivate: [ AuthGuard ]},

  { path: 'commandes', component: OrdersComponent, canActivate: [ AuthGuard ] },
  { path: 'commande/:orderid/editer', component: EditOrderComponent, canActivate: [ AuthGuard ]},
  //{ path: 'commande/ajouter', component: AddOrderComponent, canActivate: [ AuthGuard ]},

  { path: 'ajouter-soumission/:clientid/ajouter', component: AddSubmissionComponent, canActivate: [ AuthGuard ] },
  { path: 'soumissions', component: SubmissionsComponent, canActivate: [ AuthGuard ] },
  { path: 'soumission/:submissionid/editer', component: EditSubmissionComponent, canActivate: [ AuthGuard ] },
  
  { path: 'ajouter-proposition', component: AddPropositionComponent, canActivate: [ AuthGuard ] },
  
  { path: 'gestion', component: ManagementComponent, canActivate: [ AuthGuard ] },
  { path: 'bondecommande', component: EditOrdertemplateComponent, canActivate: [ AuthGuard ] },
  { path: 'usagers', component: UsersComponent, canActivate: [ AuthGuard ] },
  { path: 'usager/:userid/editer', component: EditUserComponent, canActivate: [ AuthGuard ] },
  { path: 'soustraitants', component: ContractorsComponent, canActivate: [ AuthGuard ] },
  { path: 'soustraitant/ajouter', component: AddContractorComponent, canActivate: [ AuthGuard ] },
  { path: 'soustraitant/:contractorid/editer', component: EditContractorComponent, canActivate: [ AuthGuard ] },
  { path: 'maquettes', component: TemplatesComponent, canActivate: [ AuthGuard ]},
  { path: 'maquette/ajouter', component: AddTemplateComponent, canActivate: [ AuthGuard ]},
  { path: 'maquette/:templateid/editer', component: EditTemplateComponent, canActivate: [ AuthGuard ]},
  { path: 'propositions', component: PropositionsComponent, canActivate: [ AuthGuard ] },
  
  { path: 'calendrier', component: CalendarComponent, canActivate: [ AuthGuard ]  },
  { path: 'chantier', component: CalendarForemanComponent, canActivate: [ AuthGuard ]  },
  { path: 'calendrier-jobs', component: CalendarJobsComponent, canActivate: [ AuthGuard ]  },
  { path: 'calendrier-suivis', component: FollowUpsComponent, canActivate: [ AuthGuard ] },

  { path: 'connexion', component: AuthGuard, canActivate: [AuthGuard] },
  { path: '', redirectTo: '/connexion', pathMatch: 'full' }, // redirect to `first-component`
  // { path: '**', component: PageNotFoundComponent },  // Wildcard route for a 404 page
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'disabled',
    scrollOffset: [0, 624] // [x, y]
  })],
  exports: [RouterModule],
  providers: [ AuthGuard ]
})
export class AppRoutingModule { }
